module.exports = __webpack_public_path__ + "img/up.030f7094.png";